"use strict";

exports.__esModule = true;
exports.default = void 0;
var _module = {};
[{
  key: 'appName',
  getFn: function getFn() {
    return navigator.appName;
  }
}, {
  key: 'platform',
  getFn: function getFn() {
    return navigator.platform;
  }
}, {
  key: 'screenWidth',
  getFn: function getFn() {
    return window.screen.width / window.devicePixelRatio;
  }
}, {
  key: 'screenHeight',
  getFn: function getFn() {
    return window.screen.height / window.devicePixelRatio;
  }
}, {
  key: 'appVersion',
  getFn: function getFn() {
    return navigator.appVersion;
  }
}, {
  key: 'devicePixelRatio',
  getFn: function getFn() {
    return window.devicePixelRatio;
  }
}].forEach(function (_ref) {
  var key = _ref.key,
      getFn = _ref.getFn;
  Object.defineProperty(_module, key, {
    get: getFn
  });
});
var _default = _module;
exports.default = _default;